import React from 'react';
import { Box, Typography } from '@mui/material';
import { Record } from '../csv-users-upload/types';
import { RECORD_STATUSES } from '../../api/types';
import { useTranslation } from 'react-i18next';

const CSVRecord: React.FC<Record> = ({ label, status, errors }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ padding: '10px 0', display: 'flex' }}>
            <Typography sx={{ fontSize: '14px', lineHeight: '20px', color: 'common.grey1', minWidth: '90px' }}>
                {label}
            </Typography>
            <Typography sx={{ fontSize: '14px', lineHeight: '20px' }}>
                {status === RECORD_STATUSES.CONFLICT ? t('duplicate') : t(status.toLowerCase())} {errors}
            </Typography>
        </Box>
    );
};

export default CSVRecord;
